import React, { memo } from "react";
import * as Styles from "./number-input.styles";

export const NumberInput = memo(({ name, value, onChange }) => {
  return <Styles.Input name={name} value={value} onChange={onChange} min="1" />;
});
